const insertStarterAtCursor = (
    textarea,
    starter
) => {
    const currentValue =
        textarea.value ?? '';

    const selectionStart =
        textarea.selectionStart
        ?? currentValue.length;

    const selectionEnd =
        textarea.selectionEnd
        ?? selectionStart;

    const before =
        currentValue.slice(
            0,
            selectionStart
        );

    const after =
        currentValue.slice(
            selectionEnd
        );

    const needsLeadingSpace =
        before.length > 0
        && !/\s$/.test(before);

    const needsTrailingSpace =
        after.length > 0
        && !/^\s/.test(after);

    const insertedText =
        (
            needsLeadingSpace
                ? ' '
                : ''
        )
        + starter
        + (
            needsTrailingSpace
                ? ' '
                : ''
        );

    textarea.value =
        before
        + insertedText
        + after;

    const nextCursorPosition =
        before.length
        + insertedText.length;

    textarea.setSelectionRange(
        nextCursorPosition,
        nextCursorPosition
    );

    textarea.dispatchEvent(
        new Event(
            'input',
            {
                bubbles: true,
            }
        )
    );

    textarea.focus();
};

document.addEventListener(
    'click',
    (event) => {
        const button =
            event.target.closest(
                '[data-message-starter]'
            );

        if (! button) {
            return;
        }

        const composer =
            button.closest(
                '[data-message-composer]'
            );

        if (! composer) {
            return;
        }

        const textarea =
            composer.querySelector(
                'textarea[name="body"]'
            );

        if (! textarea) {
            return;
        }

        const starter =
            button.dataset
                .messageStarter
                ?.trim();

        if (! starter) {
            return;
        }

        insertStarterAtCursor(
            textarea,
            starter
        );
    }
);
